import { ReactNode } from 'react'

interface CardContentProps {
	children: ReactNode | ReactNode[]
}

const CardContent = ({ children }: CardContentProps) => {
	return <div className="p-4 border-t border-gray-100 dark:border-gray-800 sm:p-6">{children}</div>
}

export default CardContent
